import { Controller } from "stimulus"

export default class extends Controller {
  countrySelect;
  stateSelect;
  stateRequired = false;

  updateState(country) {
    let hasStates = false;
    Array.from(this.stateSelect.options).forEach(function (option_element) {
      let option_value = option_element.value;
      if (option_value === '' || option_value === 'OTHER' || option_value.startsWith(country)) {
        option_element.removeAttribute('hidden');
        hasStates = hasStates || option_value.startsWith(country);
      } else {
        option_element.setAttribute('hidden', 'hidden');
      }
    });

    this.stateSelect.selectedIndex = 0;
    // a required state select must not block countries without states
    if (this.stateRequired) {
      this.stateSelect.required = hasStates;
    }
  }

  connect() {
    this.element.querySelectorAll('select').forEach((select) => {
      if (select.id.endsWith('countryselect-1') || select.id.endsWith('lux_email4link_country')) {
        this.countrySelect = select;
      }
      if (select.id.endsWith('stateselect-1') || select.id.endsWith('lux_email4link_state')) {
        this.stateSelect = select;
      }
    });

    if (this.countrySelect && this.stateSelect) {
      this.stateRequired = this.stateSelect.required;
      this.countrySelect.addEventListener('input', () => { this.updateState(this.countrySelect.value)});
      this.updateState(this.countrySelect.value);
    }
  }
}
